import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { SessionCountdown } from './SessionCountdown';
interface PriceCTAProps {
  id?: string;
}
export function PriceCTA({
  id
}: PriceCTAProps) {
  return <section id={id} className="w-full px-4 py-20 bg-sage/10" data-id="element-252">
      <div className="max-w-4xl mx-auto text-center" data-id="element-253">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-254">
          <div className="inline-block bg-sage text-ivory text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-widest mb-4" data-id="element-255">
            Oferta activa solo por esta semana
          </div>

          <h2 className="text-3xl md:text-5xl font-serif text-ink" data-id="element-256">
            Empieza hoy por menos de lo que cuesta una cena fuera
          </h2>

          <div className="flex flex-col items-center justify-center gap-4 py-6" data-id="element-257">
            <div className="flex items-end gap-4" data-id="element-258">
              <span className="text-2xl text-muted line-through decoration-1" data-id="element-259">
                $39.99
              </span>
              <span className="text-6xl font-serif text-clay font-bold" data-id="element-260">
                $9.99 <span className="text-2xl" data-id="element-261">USD</span>
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-262">
              <span className="bg-clay text-ivory text-sm font-bold px-3 py-1 rounded-full" data-id="element-263">
                75% OFF
              </span>
              <span className="text-sm font-medium text-taupe flex items-center gap-1.5" data-id="element-264">
                Termina en: <SessionCountdown className="font-bold text-clay" data-id="element-265" />
              </span>
            </div>
          </div>

          <a href="https://www.epikkastore.com/cart/45160332132375:1" onClick={() => {
          if (typeof (window as any).fbq !== 'undefined') {
            ;
            (window as any).fbq('track', 'InitiateCheckout', {
              value: 9.99,
              currency: 'USD',
              content_name: 'Apaga tu Inflamación'
            });
          }
        }} className="inline-block text-center w-full md:w-auto bg-clay hover:bg-clay-dark text-ivory text-xl font-semibold py-5 px-12 rounded-full transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 duration-200" data-id="element-266">
            Acceder a mi guía digital ahora
          </a>

          <div className="flex flex-wrap justify-center gap-x-8 gap-y-3 text-sm text-ink/70 font-medium pt-4" data-id="element-267">
            <span className="flex items-center gap-2" data-id="element-268">
              <Check className="w-4 h-4 text-sage" data-id="element-269" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-2" data-id="element-270">
              <Check className="w-4 h-4 text-sage" data-id="element-271" /> PDF descargable
            </span>
            <span className="flex items-center gap-2" data-id="element-272">
              <Check className="w-4 h-4 text-sage" data-id="element-273" /> Devolución 7 días
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}